/**
 * Friendly labels for the assistant's in-flight tool activity (the SSE `tool`
 * event carries the raw tool name). Unknown names — new tools ship server-side
 * first — fall back to a generic line rather than leaking an identifier.
 */
const TOOL_LABELS: Record<string, string> = {
  list_my_slots: 'checking your account…',
  get_slot_standing: 'checking your points…',
  get_rank_progress: 'checking your rank…',
  get_wallet: 'checking your wallet…',
  get_recent_ledger: 'checking your transactions…',
  get_earnings_breakdown: 'checking your earnings…',
  list_my_orders: 'checking your orders…',
  get_team_summary: 'checking your team…',
  get_payout_info: 'checking payout details…',
  get_announcements: 'checking announcements…',
  search_past_chats: 'looking through your past chats…',
  read_past_chat: 'reading a past chat…',
  navigate: 'finding the right page…',
  save_memory: 'saving a note…',
  web_search: 'searching the web…',
};

export function toolActivityLabel(name: string): string {
  return TOOL_LABELS[name] ?? 'working on it…';
}
